module.exports = __webpack_public_path__ + "img/inter_handwrite.9dfc6495.svg";